module.exports = __webpack_public_path__ + "img/60pt@3x.1410e644.png";